// extracted by mini-css-extract-plugin
export default {"wrapper":"StatButton_wrapper__TvO3Y","icon":"StatButton_icon__rE-9w","blue":"StatButton_blue__MSqq2"};